module.exports = __webpack_public_path__ + "static/media/16.aae70615.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/16.png
// module id = 382
// module chunks = 0